import * as z from "zod/v4";

export const getContextualSettings = {
  name: "getContextualSettings" as const,
  input: z.object({}),
  output: z.object({
    enabled: z.boolean(),
    contextualMerchantId: z.string().nullable(),
  }),
};
